var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 176,
    viewBox: "0 0 213 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.591 91.4121C196.591 115.056 186.825 136.369 171.166 151.688C155.843 166.84 134.628 175.998 111.223 175.998C87.9865 175.998 66.7707 166.674 51.2798 151.688C35.6205 136.369 25.8545 115.056 25.8545 91.4121C25.8545 44.6234 64.0766 6.82617 111.223 6.82617C158.369 6.82617 196.591 44.7899 196.591 91.4121Z",
    fill: "#F2EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.183 35.9681C192.996 35.9681 196.086 32.9116 196.086 29.1413C196.086 25.3709 192.996 22.3145 189.183 22.3145C185.37 22.3145 182.279 25.3709 182.279 29.1413C182.279 32.9116 185.37 35.9681 189.183 35.9681Z",
    fill: "#F2EAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.285 9.32443C201.889 9.32443 204 7.23709 204 4.66222C204 2.08735 201.889 0 199.285 0C196.681 0 194.571 2.08735 194.571 4.66222C194.571 7.23709 196.681 9.32443 199.285 9.32443Z",
    fill: "#F2EAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5486 35.801C31.1524 35.801 33.2632 33.7137 33.2632 31.1388C33.2632 28.5639 31.1524 26.4766 28.5486 26.4766C25.9448 26.4766 23.834 28.5639 23.834 31.1388C23.834 33.7137 25.9448 35.801 28.5486 35.801Z",
    fill: "#F2EAF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7557 125.713C22.5914 125.713 26.5115 121.837 26.5115 117.055C26.5115 112.273 22.5914 108.396 17.7557 108.396C12.9201 108.396 9 112.273 9 117.055C9 121.837 12.9201 125.713 17.7557 125.713Z",
    fill: "#F2EAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.166 47.123V151.69C155.844 166.842 134.628 176 111.223 176C87.9867 176 66.7709 166.676 51.28 151.69V47.123H171.166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.341 100.493L89.886 77.2988L81.9089 85.1872L105.364 108.382L113.341 100.493Z",
    fill: "#CEC5DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.579 65.7679L97.5752 100.383L105.552 108.271L140.556 73.6564L132.579 65.7679Z",
    fill: "#CEC5DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.868 122.549H80.5779V130.208H141.868V122.549Z",
    fill: "#DFD6EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.868 139.365H80.5779V147.025H141.868V139.365Z",
    fill: "#DFD6EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.882 156.352H95.5637V164.011H126.882V156.352Z",
    fill: "#DFD6EE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.61495a09b6abd9957a794de8cf18d253.svg";
export { ForwardRef as ReactComponent };